export default "__VITE_ASSET__Cg87RAoH__"